import { superCall as _$su, className as _$cn, extend as _$ex, EMPTY_OBJ as _$em, createElementVNode as _$ce } from 'intact-vue';
import { makeStyles } from './styles';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    placement = _this$get.placement,
    overlay = _this$get.overlay;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-drawer"] = true, _classNameObj[k + "-" + placement] = true, _classNameObj[makeStyles(overlay, k)] = true, _classNameObj);
  return _$su.call($this, {
    'className': _$cn(classNameObj)
  }, function ($blocks) {
    var _$blocks = {},
      __$blocks = _$ex({}, $blocks);
    return (_$blocks['_content'] = function ($super) {
      return _$ce(2, 'div', $super(), 0, _$cn(k + "-drawer-content"));
    }, __$blocks['_content'] = function ($super, data) {
      var block = $blocks['_content'];
      var callBlock = function callBlock() {
        return _$blocks['_content'].call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }), __$blocks;
  }.call($this, $blocks), $__proto__);
}
;